import type { FC } from 'react';

import { tailwindColorMap } from '../tailwind.colors';

export const GaugeLegend: FC<{ showPrediction: boolean }> = ({
  showPrediction,
}) => {
  return (
    <div className="mb-4 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-gray-600">
      <div className="flex items-center gap-2">
        <div className="h-[6px] w-[20px] bg-black" />
        <span>Current (YTD)</span>
      </div>
      {showPrediction && (
        <div className="flex items-center gap-2">
          <div className="h-0 w-[20px] border-t-2 border-dashed border-black" />
          <span>Prediction</span>
        </div>
      )}
      <div className="flex items-center gap-2">
        <div
          className="size-[10px] rounded-full"
          style={{ backgroundColor: tailwindColorMap.ok }}
        />
        <span>Guaranteed Range (Supplier Compliance)</span>
      </div>
      <div className="flex items-center gap-2">
        <div
          className="size-[10px] rounded-full"
          style={{ backgroundColor: tailwindColorMap.warning }}
        />
        <span>Below Guaranteed Range (Supplier Non-Compliance)</span>
      </div>
    </div>
  );
};
